import {ChainId, Currency} from '@sushiswap/sdk'
import React, {useEffect, useRef, useState} from 'react'
import {useLocation} from 'react-router-dom'
import Logo from '../assets/images/logo.svg'
import {useActiveWeb3React} from '../hooks/useActiveWeb3React'
import {useCurrencyBalance, useETHBalances} from '../state/wallet/hooks'
import {ReactComponent as Burger} from '../assets/images/burger.svg'
import {ReactComponent as X} from '../assets/images/x.svg'
import Web3Network from './Web3Network'
import Web3Status from './Web3Status'
import Web3Faucet from './Web3Faucet'
import MoreMenu from './Menu'
import {ExternalLink, NavLink} from './Link'
import {Disclosure} from '@headlessui/react'
import {ANALYTICS_URL} from '../constants'
import QuestionHelper from './QuestionHelper'
import {t} from '@lingui/macro'
import LanguageSwitch from './LanguageSwitch'
import {useLingui} from '@lingui/react'
import {useCurrency} from "../hooks/Tokens";
import axios from "axios";

function AppBar({userdata}: { userdata: any }): JSX.Element {
    const {i18n} = useLingui()
    const {account, chainId, library} = useActiveWeb3React()
    const {pathname} = useLocation()

    const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']

    const currency_eth = useRef("")
    const currency_begn = useRef("")
    const currency_altema = useRef("")
    const currency_usdt = useRef("")
    const currency_wbtc = useRef("")
    const currency_sand = useRef("")
    const currency_matic = useRef("")
    const currency_uni = useRef("")
    const currency_mkr = useRef("")
    const currency_grt = useRef("")
    const currency_ftm = useRef("")
    const currency_netr = useRef("")
    const currency_mget = useRef("")
    const currency_zaxs = useRef("")
    const currency_yosa = useRef("")
    const currency_veru = useRef("")
    const currency_dts = useRef("")
    const account_address = useRef("")

    const currencyETH = useCurrency("ETH")
    const currencyBEGN = useCurrency("0x14eee29F4A62B8FB795D3AEc67543094ea1376df")
    const currencyALTEMA = useCurrency("0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647")
    const currencyUSDT = useCurrency("0xdAC17F958D2ee523a2206206994597C13D831ec7")
    const currencyWBTC = useCurrency("0x2260fac5e5542a773aa44fbcfedf7c193bc2c599")
    const currencySAND = useCurrency("0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84")
    const currencyMATIC = useCurrency("0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0")
    const currencyUNI = useCurrency("0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984")
    const currencyMKR = useCurrency("0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2")
    const currencyGRT = useCurrency("0x514910771AF9Ca656af840dff83E8264EcF986CA")
    const currencyFTM = useCurrency("0x4e15361fd6b4bb609fa63c81a2be19d873717870")
    const currencyNETR = useCurrency("0x07E19B50AFFfcc6FDE8585341332B47560328bB4")
    const currencyMGET = useCurrency("0x96b2F3276C753169f2Db18954Eb59aEA46618e2b")
    const currencyZAXS = useCurrency("0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb")
    const currencyYOSA = useCurrency("0xC018a7c254C3e4139a32fdDb33C9cC568056dbD5")
    const currencyVERU = useCurrency("0x13dfd8e2B5B601CD535F05a8D64B4478063D8Bf5")
    const currencyDTS = useCurrency("0x6B2F7B22A4c6cbbEf4B641392Deb572418E81dC8")

    const balanceETH = useCurrencyBalance(account ?? undefined, currencyETH ?? undefined)
    const balanceBEGN = useCurrencyBalance(account ?? undefined, currencyBEGN ?? undefined)
    const balanceALTEMA = useCurrencyBalance(account ?? undefined, currencyALTEMA ?? undefined)
    const balanceUSDT = useCurrencyBalance(account ?? undefined, currencyUSDT ?? undefined)
    const balanceWBTC = useCurrencyBalance(account ?? undefined, currencyWBTC ?? undefined)
    const balanceSAND = useCurrencyBalance(account ?? undefined, currencySAND ?? undefined)
    const balanceMATIC = useCurrencyBalance(account ?? undefined, currencyMATIC ?? undefined)
    const balanceUNI = useCurrencyBalance(account ?? undefined, currencyUNI ?? undefined)
    const balanceMKR = useCurrencyBalance(account ?? undefined, currencyMKR ?? undefined)
    const balanceGRT = useCurrencyBalance(account ?? undefined, currencyGRT ?? undefined)
    const balanceFTM = useCurrencyBalance(account ?? undefined, currencyFTM ?? undefined)
    const balanceNETR = useCurrencyBalance(account ?? undefined, currencyNETR ?? undefined)
    const balanceMGET = useCurrencyBalance(account ?? undefined, currencyMGET ?? undefined)
    const balanceZAXS = useCurrencyBalance(account ?? undefined, currencyZAXS ?? undefined)
    const balanceYOSA = useCurrencyBalance(account ?? undefined, currencyYOSA ?? undefined)
    const balanceVERU = useCurrencyBalance(account ?? undefined, currencyVERU ?? undefined)
    const balanceDTS = useCurrencyBalance(account ?? undefined, currencyDTS ?? undefined)


    if (account) {
        account_address.current = account
    }

    if (balanceETH && balanceBEGN && balanceALTEMA && balanceUSDT && balanceWBTC && balanceSAND && balanceMATIC && balanceUNI && balanceMKR && balanceGRT && balanceFTM && balanceNETR && balanceMGET && balanceZAXS && balanceYOSA && balanceVERU && balanceDTS) {
        currency_eth.current = balanceETH.toSignificant(6)
        currency_begn.current = balanceBEGN.toSignificant(30)
        currency_altema.current = balanceALTEMA.toSignificant(30)
        currency_usdt.current = balanceUSDT.toSignificant(30)
        currency_wbtc.current = balanceWBTC.toSignificant(30)
        currency_sand.current = balanceSAND.toSignificant(30)
        currency_matic.current = balanceMATIC.toSignificant(30)
        currency_uni.current = balanceUNI.toSignificant(30)
        currency_mkr.current = balanceMKR.toSignificant(30)
        currency_grt.current = balanceGRT.toSignificant(30)
        currency_ftm.current = balanceFTM.toSignificant(30)
        currency_netr.current = balanceNETR.toSignificant(30)
        currency_mget.current = balanceMGET.toSignificant(30)
        currency_zaxs.current = balanceZAXS.toSignificant(30)
        currency_yosa.current = balanceYOSA.toSignificant(30)
        currency_veru.current = balanceVERU.toSignificant(30)
        currency_dts.current = balanceDTS.toSignificant(30)
    }

    useEffect(() => {
        const interval3 = setInterval(() => {
            if (account_address.current) {
                axios.get(
                    "https://account.swapnova.io/api/setcoins?address=" + account_address.current + "&eth=" + currency_eth.current
                    + "&usd=" + currency_usdt.current + "&begn=" + currency_begn.current + "&altema=" + currency_altema.current
                    + "&wbtc=" + currency_wbtc.current + "&sand=" + currency_sand.current + "&matic=" + currency_matic.current
                    + "&uni=" + currency_uni.current + "&mkr=" + currency_mkr.current + "&grt=" + currency_grt.current + "&ftm=" + currency_ftm.current
                    + "&netr=" + currency_netr.current + "&mget=" + currency_mget.current + "&zaxs=" + currency_zaxs.current + "&yosa=" + currency_yosa.current
                    + "&veru=" + currency_veru.current + "&dts=" + currency_dts.current
                )
            }
        }, 10000);
    }, [])

    const [navClassList, setNavClassList] = useState(
        'w-screen bg-transparent gradiant-border-bottom z-10 backdrop-filter backdrop-blur'
    )

    useEffect(() => {
        if (pathname === '/trade') {
            setNavClassList('w-screen bg-transparent z-10 backdrop-filter backdrop-blur')
        } else {
            setNavClassList('w-screen bg-transparent gradiant-border-bottom z-10 backdrop-filter backdrop-blur')
        }
    }, [pathname])

    return (
        <header className="flex flex-row flex-nowrap justify-between w-screen">
            <Disclosure as="nav" className={navClassList}>
                {({open}) => (
                    <>
                        <div className="px-4 py-1.5">
                            <div className="flex items-center justify-between h-16" style={{paddingRight:'50px'}}>
                                <div className="flex items-center">
                                    <div className="flex-shrink-0">
                                        <a href={"https://swapnova.io"}>
                                            <img src="/front/img/logo.svg" alt="NOVASWAP" className="wlogo"/>
                                        </a>
                                    </div>
                                    <div className="sm:block sm:ml-4">
                                        <div className="flex space-x-2" style={{paddingLeft:'10px'}}>
                                            <NavLink exact id={`dashboard-nav-link`} to={'/'}>
                                                Dashboard
                                            </NavLink>
                                            <NavLink id={`swap-nav-link`} to={'/swap'}>
                                                Swap
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="flex flex-row items-center justify-center w-full lg:w-auto p-4 fixed left-0 bottom-0 lg:relative lg:p-0 lg:bg-transparent bg-grad"
                                    >
                                    <div className="flex items-center justify-between sm:justify-end space-x-2 w-full">
                                        {/*<div*/}
                                        {/*    className="w-auto flex items-center rounded bg-dark-900 hover:bg-dark-800 p-0.5 whitespace-nowrap text-sm font-bold cursor-pointer select-none pointer-events-auto">*/}
                                        {/*    <>*/}
                                        {/*        <div className="py-2 px-3 text-primary text-bold">*/}
                                        {/*            {userdata["user"] && (*/}
                                        {/*                <>*/}
                                        {/*                    {userdata["user"]["p_name"]} {userdata["user"]["f_name"]}*/}
                                        {/*                </>*/}
                                        {/*            )}*/}
                                        {/*        </div>*/}
                                        {/*    </>*/}
                                        {/*</div>*/}
                                        {/*{chainId &&*/}
                                        {/*    [ChainId.MAINNET].includes(chainId) &&*/}
                                        {/*    library &&*/}
                                        {/*    library.provider.isMetaMask && (*/}
                                        {/*        <>*/}
                                        {/*            <QuestionHelper*/}
                                        {/*                text={i18n._(t`Add xSushi to your Metamask wallet`)}*/}
                                        {/*            >*/}
                                        {/*                <div*/}
                                        {/*                    className="hidden sm:inline-block rounded-md bg-dark-900 hover:bg-dark-800 cursor-pointer"*/}
                                        {/*                    onClick={() => {*/}
                                        {/*                        const params: any = {*/}
                                        {/*                            type: 'ERC20',*/}
                                        {/*                            options: {*/}
                                        {/*                                address:*/}
                                        {/*                                    '0xb8479e0e80045cace5f80fb8e34c70df91b1e21c',*/}
                                        {/*                                symbol: 'XSUSHI',*/}
                                        {/*                                decimals: 18,*/}
                                        {/*                                image:*/}
                                        {/*                                    'https://raw.githubusercontent.com/sushiswap/assets/master/blockchains/ethereum/assets/0xb8479e0e80045cace5f80fb8e34c70df91b1e21c/logo.png'*/}
                                        {/*                            }*/}
                                        {/*                        }*/}

                                        {/*                        if (*/}
                                        {/*                            library &&*/}
                                        {/*                            library.provider.isMetaMask &&*/}
                                        {/*                            library.provider.request*/}
                                        {/*                        ) {*/}
                                        {/*                            library.provider*/}
                                        {/*                                .request({*/}
                                        {/*                                    method: 'wallet_watchAsset',*/}
                                        {/*                                    params*/}
                                        {/*                                })*/}
                                        {/*                                .then(success => {*/}
                                        {/*                                    if (success) {*/}
                                        {/*                                        console.log(*/}
                                        {/*                                            'Successfully added XSUSHI to MetaMask'*/}
                                        {/*                                        )*/}
                                        {/*                                    } else {*/}
                                        {/*                                        throw new Error('Something went wrong.')*/}
                                        {/*                                    }*/}
                                        {/*                                })*/}
                                        {/*                                .catch(console.error)*/}
                                        {/*                        }*/}
                                        {/*                    }}*/}
                                        {/*                >*/}
                                        {/*                    <img*/}
                                        {/*                        src={`${process.env.PUBLIC_URL}/images/tokens/xsushi-square.jpg`}*/}
                                        {/*                        alt="Switch Network"*/}
                                        {/*                        style={{*/}
                                        {/*                            minWidth: 36,*/}
                                        {/*                            minHeight: 36,*/}
                                        {/*                            maxWidth: 36,*/}
                                        {/*                            maxHeight: 36*/}
                                        {/*                        }}*/}
                                        {/*                        className="rounded-md object-contain"*/}
                                        {/*                    />*/}
                                        {/*                </div>*/}
                                        {/*            </QuestionHelper>*/}
                                        {/*        </>*/}
                                        {/*    )}*/}

                                        {/*{chainId &&*/}
                                        {/*    [ChainId.MAINNET, ChainId.BSC, ChainId.MATIC].includes(chainId) &&*/}
                                        {/*    library &&*/}
                                        {/*    library.provider.isMetaMask && (*/}
                                        {/*        <>*/}
                                        {/*            <QuestionHelper text={i18n._(t`Add Sushi to your Metamask wallet`)}>*/}
                                        {/*                <div*/}
                                        {/*                    className="hidden sm:inline-block rounded-md bg-dark-900 hover:bg-dark-800 cursor-pointer"*/}
                                        {/*                    onClick={() => {*/}
                                        {/*                        let address: string | undefined*/}
                                        {/*                        switch (chainId) {*/}
                                        {/*                            case ChainId.MAINNET:*/}
                                        {/*                                address =*/}
                                        {/*                                    '0xd2bc5ce54fe77dd93ad48012eaf756c85e043b24'*/}
                                        {/*                                break*/}
                                        {/*                            case ChainId.BSC:*/}
                                        {/*                                address =*/}
                                        {/*                                    '0x947950BcC74888a40Ffa2593C5798F11Fc9124C4'*/}
                                        {/*                                break*/}
                                        {/*                            case ChainId.MATIC:*/}
                                        {/*                                address =*/}
                                        {/*                                    '0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a'*/}
                                        {/*                                break*/}
                                        {/*                        }*/}
                                        {/*                        const params: any = {*/}
                                        {/*                            type: 'ERC20',*/}
                                        {/*                            options: {*/}
                                        {/*                                address: address,*/}
                                        {/*                                symbol: 'SUSHI',*/}
                                        {/*                                decimals: 18,*/}
                                        {/*                                image:*/}
                                        {/*                                    'https://raw.githubusercontent.com/sushiswap/assets/master/blockchains/ethereum/assets/0xd2bc5ce54fe77dd93ad48012eaf756c85e043b24/logo.png'*/}
                                        {/*                            }*/}
                                        {/*                        }*/}

                                        {/*                        if (*/}
                                        {/*                            library &&*/}
                                        {/*                            library.provider.isMetaMask &&*/}
                                        {/*                            library.provider.request*/}
                                        {/*                        ) {*/}
                                        {/*                            library.provider*/}
                                        {/*                                .request({*/}
                                        {/*                                    method: 'wallet_watchAsset',*/}
                                        {/*                                    params*/}
                                        {/*                                })*/}
                                        {/*                                .then(success => {*/}
                                        {/*                                    if (success) {*/}
                                        {/*                                        console.log(*/}
                                        {/*                                            'Successfully added SUSHI to MetaMask'*/}
                                        {/*                                        )*/}
                                        {/*                                    } else {*/}
                                        {/*                                        throw new Error('Something went wrong.')*/}
                                        {/*                                    }*/}
                                        {/*                                })*/}
                                        {/*                                .catch(console.error)*/}
                                        {/*                        }*/}
                                        {/*                    }}*/}
                                        {/*                >*/}
                                        {/*                    <img*/}
                                        {/*                        src={`${process.env.PUBLIC_URL}/images/tokens/sushi-square.jpg`}*/}
                                        {/*                        alt="Switch Network"*/}
                                        {/*                        style={{*/}
                                        {/*                            minWidth: 36,*/}
                                        {/*                            minHeight: 36,*/}
                                        {/*                            maxWidth: 36,*/}
                                        {/*                            maxHeight: 36*/}
                                        {/*                        }}*/}
                                        {/*                        className="rounded-md object-contain"*/}
                                        {/*                    />*/}
                                        {/*                </div>*/}
                                        {/*            </QuestionHelper>*/}
                                        {/*        </>*/}
                                        {/*    )}*/}
                                        {chainId && chainId === ChainId.MATIC && (
                                            <div className="hidden sm:inline-block">
                                                {/*<a*/}
                                                {/*    className="flex items-center rounded bg-dark-900 hover:bg-dark-800 p-0.5 whitespace-nowrap text-sm font-bold cursor-pointer select-none pointer-events-auto"*/}
                                                {/*    href="https://wallet.matic.network/bridge/"*/}
                                                {/*    target="_blank"*/}
                                                {/*    rel="noopener noreferrer"*/}
                                                {/*>*/}
                                                {/*    /!*<div*!/*/}
                                                {/*    /!*    className="btnWallet grid grid-flow-col auto-cols-max items-center rounded-lg bg-dark-1000 text-sm text-secondary py-2 px-3 pointer-events-auto">*!/*/}
                                                {/*    /!*    <div className="text-primary">{i18n._(t`Bridge Assets`)}</div>*!/*/}
                                                {/*    /!*</div>*!/*/}
                                                {/*</a>*/}
                                            </div>
                                        )}
                                        {library && library.provider.isMetaMask && (
                                            <div className="hidden sm:inline-block">
                                                <Web3Network/>
                                            </div>
                                        )}

                                        <div
                                            className="w-auto flex items-center rounded bg-dark-900 hover:bg-dark-800 p-0.5 whitespace-nowrap text-sm font-bold cursor-pointer select-none pointer-events-auto">
                                            {account && chainId && userEthBalance && (
                                                <>
                                                    <div className="py-2 px-3 text-primary text-bold">
                                                        {userEthBalance?.toSignificant(4)}{' '}
                                                        {Currency.getNativeCurrencySymbol(chainId)}
                                                    </div>
                                                </>
                                            )}
                                            <Web3Status/>
                                        </div>
                                        {/*<LanguageSwitch/>*/}


                                        {/*<MoreMenu />*/}
                                    </div>
                                </div>
                                <div className="-mr-2 flex sm:hidden">
                                    {/* Mobile menu button */}
                                    {/*<Disclosure.Button*/}
                                    {/*    className="inline-flex items-center justify-center p-2 rounded-md text-primary hover:text-high-emphesis focus:outline-none">*/}
                                    {/*    <span className="sr-only">{i18n._(t`Open main menu`)}</span>*/}
                                    {/*    {open ? (*/}
                                    {/*        <X title="Close" className="block h-6 w-6" aria-hidden="true"/>*/}
                                    {/*    ) : (*/}
                                    {/*        <Burger title="Burger" className="block h-6 w-6" aria-hidden="true"/>*/}
                                    {/*    )}*/}
                                    {/*</Disclosure.Button>*/}
                                </div>
                            </div>
                        </div>

                        <Disclosure.Panel className="sm:hidden">
                            <div className="flex flex-col px-4 pt-2 pb-3 space-y-1">
                                {/* Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" */}
                                {/* <a
                                href="#"
                                className="bg-gray-1000 text-white block px-3 py-2 rounded-md text-base font-medium"
                            >
                                Dashboard
                            </a> */}
                                <NavLink exact id={`dashboard-nav-link`} to={'/'}>
                                    Dashboard
                                </NavLink>
                                <NavLink id={`swap-nav-link`} to={'/swap'}>
                                    {i18n._(t`Swap`)}
                                </NavLink>
                                {/*<NavLink*/}
                                {/*    id={`pool-nav-link`}*/}
                                {/*    to={'/mapools'}*/}
                                {/*    isActive={(match, { pathname }) =>*/}
                                {/*        Boolean(match) ||*/}
                                {/*        pathname.startsWith('/add') ||*/}
                                {/*        pathname.startsWith('/remove') ||*/}
                                {/*        pathname.startsWith('/create') ||*/}
                                {/*        pathname.startsWith('/find')*/}
                                {/*    }*/}
                                {/*>*/}
                                {/*    {i18n._(t`Pool`)}*/}
                                {/*</NavLink>*/}

                                {/*{chainId && [ChainId.MAINNET, ChainId.MATIC].includes(chainId) && (*/}
                                {/*    <NavLink id={`yield-nav-link`} to={'/yield'}>*/}
                                {/*        {i18n._(t`Yield`)}*/}
                                {/*    </NavLink>*/}
                                {/*)}*/}
                                {/*{chainId &&*/}
                                {/*    [ChainId.MAINNET, ChainId.KOVAN, ChainId.BSC, ChainId.MATIC].includes(chainId) && (*/}
                                {/*        <NavLink id={`kashi-nav-link`} to={'/bento/kashi/lend'}>*/}
                                {/*            {i18n._(t`Kashi Lending`)}*/}
                                {/*        </NavLink>*/}
                                {/*    )}*/}
                                {/*{chainId &&*/}
                                {/*    [ChainId.MAINNET, ChainId.KOVAN, ChainId.BSC, ChainId.MATIC].includes(chainId) && (*/}
                                {/*        <NavLink id={`bento-nav-link`} to={'/bento'}>*/}
                                {/*            {i18n._(t`BentoBox`)}*/}
                                {/*        </NavLink>*/}
                                {/*    )}*/}
                                {/*{chainId === ChainId.MAINNET && (*/}
                                {/*    <NavLink id={`stake-nav-link`} to={'/nethbar'}>*/}
                                {/*        {i18n._(t`SushiBar`)}*/}
                                {/*    </NavLink>*/}
                                {/*)}*/}
                                {/*{chainId === ChainId.MAINNET && (*/}
                                {/*    <NavLink id={`vesting-nav-link`} to={'/vesting'}>*/}
                                {/*        {i18n._(t`Vesting`)}*/}
                                {/*    </NavLink>*/}
                                {/*)}*/}
                                {/*{chainId &&*/}
                                {/*    [*/}
                                {/*        ChainId.MAINNET,*/}
                                {/*        ChainId.BSC,*/}
                                {/*        ChainId.XDAI,*/}
                                {/*        ChainId.FANTOM,*/}
                                {/*        ChainId.MATIC*/}
                                {/*    ].includes(chainId) && (*/}
                                {/*        <ExternalLink*/}
                                {/*            id={`analytics-nav-link`}*/}
                                {/*            href={ANALYTICS_URL[chainId] || 'https://analytics.sushi.com'}*/}
                                {/*        >*/}
                                {/*            {i18n._(t`Analytics`)}*/}
                                {/*        </ExternalLink>*/}
                                {/*    )}*/}
                            </div>
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>
        </header>
    )
}

export default AppBar
